import { Box, CircularProgress, Paper, Typography } from "@mui/material";
import { alpha, useTheme } from "@mui/material/styles";

interface GridLockOverlayProps {
	isProcessing: boolean;
	/** Optional message displayed below the spinner. */
	message?: string;
}

const GridLockOverlay = ({ isProcessing, message }: GridLockOverlayProps) => {
	const theme = useTheme();

	if (!isProcessing) {
		return null;
	}

	return (
		<Box
			sx={{
				alignItems: "center",
				backgroundColor: alpha(theme.palette.background.paper, 0.6),
				display: "flex",
				inset: 0,
				justifyContent: "center",
				position: "absolute",
				zIndex: 1000
			}}
		>
			<Paper
				elevation={4}
				sx={{
					alignItems: "center",
					display: "flex",
					flexDirection: "column",
					gap: 2,
					minWidth: 220,
					px: 4,
					py: 3
				}}
			>
				<CircularProgress color="primary" size={64} />
				{message && (
					<Typography color="text.primary" fontWeight={500} variant="body1">
						{message}
					</Typography>
				)}
			</Paper>
		</Box>
	);
};

export default GridLockOverlay;
